import { render, staticRenderFns } from "./ModalViewNote.vue?vue&type=template&id=2d9f6b6a&"
import script from "./ModalViewNote.vue?vue&type=script&lang=js&"
export * from "./ModalViewNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports